module.exports = __webpack_public_path__ + "static/media/odiopay-logo.38b9f96d.svg";